import React from 'react';
import { Routes, Route } from 'react-router-dom';
require('../../scss/style.scss');

import NonCertifiedEmployeesWorkdays from '../containers/non-certified-employees-workdays'
import CertifiedEmployeesWorkdays from '../containers/certified-employees-workdays';
import ClaimsEmployeesWorkdays from '../containers/claims-employees-workdays';
import AcceptedClaims from '../containers/acceptedClaims';
import RejectedClaims from '../containers/rejectedClaims';
import AuditTrail from '../containers/AuditTrail';
import Outlaw from '../containers/outlaw';


import Login from '../containers/login';
import ImpersonateLogin from '../containers/impersonateLogin';
import Workdays from '../containers/workdays';
import PageNotFound from './pageNotFound';

import authComponent from './requireAuth';
import ManuallyUpdate from '../containers/manuallyUpdate';
import NonCertifiedPre16EmployeesWorkdays from '../containers/non-certified-pre16-employees-workdays';
import Configurations from '../containers/Configurations';
import HOSLogsWorkdays from '../containers/hos-logs-workdays';
import greaterThan12HoslogWorkdays from '../containers/greaterThan12HoslogWorkdays';
import nonCertifiedHoslogWorkdays from '../containers/nonCertifiedHoslogWorkdays';
import CertifiedHOSLogsWorkDays from '../containers/certifiedHoslogWorkdays';
import UserHOSLogsWorkdays from '../containers/user-hos-log-workdays';
import FRAReportWorkdays from '../containers/fra-report-workdays';
import Series from '../containers/workday-series';
import Series14 from '../containers/series14';
import UserHistoricalWorkdays from '../containers/userHistoricalWorkdays'
import HastusToTCE from '../containers/HastusToTCE';


function RoutesComponent (){


        return(
        
                <div className="mainBody">
                <Routes>
                <Route exact path="/" element={authComponent(Login)} />
                    <Route  path="/workdays" element={authComponent(Workdays)} />    
                    <Route exact path="/noncertified" element={authComponent(NonCertifiedEmployeesWorkdays)} />
                    <Route exact path="/certified"   element={authComponent(CertifiedEmployeesWorkdays)} />
                    <Route exact path="/claims" element={authComponent(ClaimsEmployeesWorkdays)} />
                    <Route exact path="/acceptedclaims" element={authComponent(AcceptedClaims)} /> 
                    <Route exact path="/rejectedclaims" element={authComponent(RejectedClaims)} />
                    <Route exact path="/outlaw" element={authComponent(Outlaw)} />
                    <Route exact path="/audittrail" element={authComponent(AuditTrail)} />
                    <Route exact path="/manuallyupdate" element={authComponent(ManuallyUpdate)} />
                    <Route exact path="/noncertifiedPre16" element={authComponent(NonCertifiedPre16EmployeesWorkdays)} />
                    <Route exact path="/configurations" element={authComponent(Configurations)} />
                    <Route exact path="/hoslogsworkdays" element={authComponent(HOSLogsWorkdays)} />
                    <Route exact path="/userhoslogsworkdays" element={authComponent(UserHOSLogsWorkdays)} />
                    <Route exact path="/admin" element={authComponent(ImpersonateLogin)} />
                    <Route exact path="/frareport" element={authComponent(FRAReportWorkdays)} />
                    <Route exact path="/series" element={authComponent(Series)} />
                    <Route exact path="/series14" element={authComponent(Series14)} />
                    <Route exact path="/hoslogsu/:status" element={authComponent(nonCertifiedHoslogWorkdays)} />
                    <Route exact path="/hoslogsc/:status" element={authComponent(CertifiedHOSLogsWorkDays)} />
                    <Route exact path="/hoslogs/:greater12" element={authComponent(greaterThan12HoslogWorkdays)} />
                    <Route exact path="/hastusToTCE" element={authComponent(HastusToTCE)} />
                    <Route exact path="/historicalWorkdays" element={authComponent(UserHistoricalWorkdays)} />
                    
                </Routes>
                </div>
             
           
        )    
}

export default RoutesComponent;
